export const globalButtonStyle = {
  padding: "10px 25px",
  border: "none",
  borderRadius: "10px",
  color: "white",
  fontSize: "20px",
  cursor: "pointer",
  boxShadow: "0 4px 8px rgb(250, 150, 0, 0.6)"
}

export const globalButtonHoverStyle = {
  backgroundColor: "orange",
  boxShadow: "none"
}
